<div class="rule">
  <div class="row auto">
  <wire-field-option [rule]="rule" [value]="rule.field" [fields]="fields" (selectedFieldChanged)="onFieldChange($event)"></wire-field-option>
  <wire-query-operator [rule]="rule" [field]="fields[rule.field]" (selectedOperatorChanged)="onOperatorChange($event)"></wire-query-operator>
  <wire-query-value [fields]="fields" [rule]="rule" [operator]="rule.operator" [selectedField]="fields[rule.field]" (valueChanged)="onValueChanged()"></wire-query-value>
    </div>
    <button type="button" mat-icon-button color="primary" class="trash-button" (click)="removeRule()" data-testid="qb-remove-rule">
      <mat-icon class="button-icon"><i class="fa fa-trash"></i></mat-icon>
    </button>
</div>
